/* eslint-disable */
import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Box from '@mui/material/Box';
import { TableSortLabel, Button } from '@mui/material';
import _ from 'lodash';
import { visuallyHidden } from '@mui/utils';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import dayjs from 'dayjs';
import addCommas from '../utils/functions/commas';
import DetailRejectSuperAdminPopup from './PaymentDetail/RejectDetailSuperAdmin';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const columns = [
  {
    id: 'upload_ref_id',
    label: 'เลขอ้างอิงรายการชำระเงิน',
    align: 'center',
  },
  {
    id: 'company_name',
    label: 'ชื่อร้านค้า',
    align: 'center',
  },
  {
    id: 'order_id',
    label: 'เลขอ้างอิงรายการของร้านค้า',
    align: 'center',
  },
  {
    id: 'date_pay',
    label: 'วันที่ชำระเงิน',
    align: 'center',
  },
  {
    id: 'time_pay',
    label: 'เวลาที่ชำระเงิน',
    align: 'center',
  },
  {
    id: 'amount',
    label: 'จำนวนเงิน',
    align: 'right',
  },
  {
    id: 'action',
    label: ' ',
    align: 'center',
    minWidth: 250,
  },
];

function TableRejectSuperAdmin({
  isrejectSuperAdmin,
  handleRequestSort,
  orderDirection,
  valueToOrderBy,
  pagination,
  handlePaginationChange,
}) {
  const [page, setPage] = useState(pagination.currPage - 1);
  const [rowsPerPage, setRowsPerPage] = useState(pagination.size);
  const [detailPopupOpen, setDetailPopupOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const createSortHead = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    handlePaginationChange('handleChangePage', newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setRowsPerPage(newSize);
    setPage(0);
    handlePaginationChange('handleChangeRowsPerPage', newSize);
  };

  const handleOpenDetailPopup = (rowData) => {
    setSelectedRowData(rowData);
    setDetailPopupOpen(true);
  };

  const handleCloseDetailPopup = () => {
    setDetailPopupOpen(false);
    setSelectedRowData(null);
  };

  return (
    <>
      <TableContainer sx={{ maxHeight: 460, overflowY: 'auto' }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, color: '#fff' }}
                >
                  <TableSortLabel
                    active={valueToOrderBy === column.id}
                    direction={
                      valueToOrderBy === column.id
                        ? _.toLower(orderDirection)
                        : _.toLower('asc')
                    }
                    onClick={createSortHead(column.id)}
                  >
                    {column.label}
                    {valueToOrderBy === column.id ? (
                      <Box component="span" sx={visuallyHidden}>
                        {orderDirection === 'desc'
                          ? 'sorted descending'
                          : 'sorted ascending'}
                      </Box>
                    ) : null}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {_.size(isrejectSuperAdmin) ? (
            <TableBody>
              {isrejectSuperAdmin
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow
                    key={index}
                    // sx={{
                    //   '&:last-child td, &:last-child th': { border: 0 },
                    // }}
                    // className="hover:bg-gray-200 cursor-pointer"
                  >
                    <TableCell align="center">
                      {row.upload_ref_id ? row.upload_ref_id : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.company_name ? row.company_name : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.order_id ? row.order_id : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.date_pay
                        ? dayjs(row.date_pay, 'YYYYMMDD').format('DD-MM-YYYY')
                        : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.time_pay
                        ? dayjs(row.time_pay, 'HHmm').format('HH:mm')
                        : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.amount ? addCommas(row.amount) : '-'}
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        sx={{
                          color: '#fff',
                          width: 140,
                          backgroundColor: '#0F4898',
                          borderRadius: '15px',
                        }}
                        variant="contained"
                        onClick={() => handleOpenDetailPopup(row)}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#0F4898'; // Keep the color same on hover
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = '#0F4898'; // Keep the color same when not hovering
                        }}
                      >
                        <RemoveRedEyeIcon />
                        <span className="mr-1 ml-1" />
                        รายละเอียด
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colSpan={10} align="center">
                  <div>ไม่มีข้อมูล</div>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={pagination.total}
        rowsPerPage={pagination.size}
        page={pagination.currPage - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <DetailRejectSuperAdminPopup
        open={detailPopupOpen}
        onClose={handleCloseDetailPopup}
        rowData={selectedRowData}
      />
    </>
  );
}

export default TableRejectSuperAdmin;
